
import {createSlice} from '@reduxjs/toolkit'
import { fetchbranchservicetype } from '../../action/master/branchservicetypeAction'

interface branchservicetypeState {
  data: any
  status: 'idle' | 'loading' | 'succeeded' | 'failed'
  error: string | null
}

const initialState: branchservicetypeState = {
  data: null,
  status: 'idle',
  error: null,
}

const branchservicetypeSlice = createSlice({
  name: 'branchservicetype',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchbranchservicetype.pending, (state) => {
        state.status = 'loading'
      })
      .addCase(fetchbranchservicetype.fulfilled, (state, action) => {
        state.status = 'succeeded'
        state.data = action.payload
        
      })
      .addCase(fetchbranchservicetype.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action.error.message || 'Failed to fetch business type data'
      })
  },
})

export default branchservicetypeSlice.reducer
